import React from 'react';

import CloseIcon from 'images/icon/close.inline.svg';

import { useLogin } from 'models/login';

import styles from './index.module.css';

interface MemberJoinModalMobileProperty {
	onCloseClick: () => void;
	afterJoinMemberClick?: () => void;
}

const MemberJoinModalMobile: React.FC<MemberJoinModalMobileProperty> = ({
	onCloseClick = () => {},
	afterJoinMemberClick = () => {},
}) => {
	const [, { getIsMember, createMember }] = useLogin();

	const onJoinMemberClick = async () => {
		await createMember();
		await getIsMember();
		afterJoinMemberClick();
	};

	return (
		<div className={styles.modalMask}>
			<div className={styles.modalMobile}>
				<div className={styles.optionRow}>
					<div
						className={styles.closeIconBox}
						role="button"
						tabIndex={0}
						onKeyPress={() => {}}
						onClick={onCloseClick}
					>
						<CloseIcon />
					</div>
				</div>
				<div className={styles.functionArea}>
					<div className={styles.textBox}>
						<div className={styles.title}>GR Fan Club</div>
						<div className={styles.text}>踩下油門，見證 GR 極致性能！</div>
					</div>
					<div
						className={styles.joinBtn}
						role="button"
						tabIndex={0}
						onKeyPress={() => {}}
						onClick={onJoinMemberClick}
					>
						<div className={styles.p}>加入 GR Fan Club</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default MemberJoinModalMobile;
